const d3 = require("d3");
const TIMEPARSER = d3.timeParse("%Y-%m-%d");
const TIMEFORMATTER = d3.timeFormat("%B");
const selectStep1ID = '#select-step1', selectStep2ID = '#select-step2', selectStep3ID = "#select-step3";
const lineChartID = "#lineChartDiv";
const lineBtnID = "#lineBtn";
const svgLinesID = '#svgLineChart';
const gLinesID = "#lineG";
const riLineID = "#line-RI";
const nonRILineID = "#line-nonRI";
const lineZeroID = "#line-zero";
const heightLineChartDiv = 600, widthLineChartDiv = 900;
const paddingSVG = 100; //the padding between div and svg canvas
const paddingScale = 50; //the padding between svg and the axes
const xScaleRange = [paddingScale, widthLineChartDiv-paddingSVG-paddingScale];
const yScaleRange = [heightLineChartDiv-paddingSVG-paddingScale, paddingScale];
const translate_xAxis = `translate(0, ${yScaleRange[0]})`;
const translate_yAxis = `translate(${paddingScale},0)`;
const titles = ["Retail&Recreation", "Grocery&Pharmacy", "Parks", "Transit Stations", "Workplaces", "Residential"];
const titlesData = ["RI", "RI Vs. non-RI States(Median)", "RI Vs. non-RI States(Mean)"];

const COLS = ["retail_and_recreation_percent_change_from_baseline",
    "grocery_and_pharmacy_percent_change_from_baseline",
    "parks_percent_change_from_baseline",
    "transit_stations_percent_change_from_baseline",
    "workplaces_percent_change_from_baseline",
    "residential_percent_change_from_baseline"];
const URL_RI = `https://raw.githubusercontent.com/s4-web/data/master/statesgRI.csv`;
const URL_nonRIMean = `https://raw.githubusercontent.com/s4-web/data/master/statesgNonRIMean.csv`;
const URL_nonRIMedian = `https://raw.githubusercontent.com/s4-web/data/master/statesgNonRIMedian.csv`;
const colors = ['blue','red'];
const strokeWidth = '1px';
const yTickFormat = d => d == 0 ? "baseline" : d + '%';
const URL_STATES = "https://s4.ad.brown.edu/node/gmobility/state/";
const URL_COUNTIES = "https://s4.ad.brown.edu/node/gmobility/county/";
const URL_DATESET = "https://s4.ad.brown.edu/node/gmobility/dates";
const URL_STATEGEOJSON = "https://raw.githubusercontent.com/s4-web/data/master/states52_unprj.json";
const URL_COUNTYGEOJSON = "https://raw.githubusercontent.com/s4-web/data/master/counties-10m.json";

module.exports = {TIMEPARSER,
    TIMEFORMATTER,
    selectStep1ID,
    selectStep2ID,
    selectStep3ID,
    lineChartID,
    lineBtnID,
    svgLinesID,
    gLinesID,
    riLineID,
    nonRILineID,
    lineZeroID,
    heightLineChartDiv,
    widthLineChartDiv,
    paddingSVG,
    paddingScale,
    xScaleRange,
    yScaleRange,
    translate_xAxis,
    translate_yAxis,
    COLS,
    URL_RI,
    URL_nonRIMedian,
    URL_nonRIMean,
    colors,
    strokeWidth,
    yTickFormat,
    titles,
    titlesData,
    URL_STATES,
    URL_COUNTIES,
    URL_STATEGEOJSON,
    URL_COUNTYGEOJSON,
    URL_DATESET,

}